import { Query } from "@datorama/akita";

import InstagramGalleryStore, {
    InstagramGalleryState,
} from "../stores/InstagramGalleryStore";

export class InstagramGalleriesQuery extends Query<InstagramGalleryState> {
    constructor(protected store: InstagramGalleryStore) {
        super(store);
    }
    gallery$ = this.select((v) => v.gallery);
    error$ = this.selectError();
}
export default InstagramGalleriesQuery;
